(function () {
  function initializeCloseout(root) {
    if (!root || root.dataset.sfcReady === "true") return;
    root.dataset.sfcReady = "true";

    var buttons = root.querySelectorAll("[data-sfc-filter]");
    var locations = root.querySelectorAll("[data-sfc-location]");
    var toggles = root.querySelectorAll("[data-sfc-toggle]");
    var locationTriggers = root.querySelectorAll("[data-sfc-location-trigger]");
    var liveClock = root.querySelector("[data-sfc-live-clock]");
    var liveClockDate = root.querySelector("[data-sfc-live-date]");
    var liveClockTime = root.querySelector("[data-sfc-live-time]");

    root.querySelectorAll(".sfc-model-list").forEach(function (list) {
      var models = Array.prototype.slice.call(list.children);
      models.sort(function (first, second) {
        function closeoutPrice(model) {
          var price = model.querySelector(".sfc-model__sale strong");
          return price ? Number(price.textContent.replace(/[^0-9.]/g, "")) : Number.MAX_VALUE;
        }
        return closeoutPrice(first) - closeoutPrice(second);
      });
      models.forEach(function (model) {
        list.appendChild(model);
      });
    });

    if (liveClock) {
      var dateFormatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
      var timeFormatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "short"
      });

      function updateLiveClock() {
        var now = new Date();
        liveClockDate.textContent = dateFormatter.format(now);
        liveClockTime.textContent = timeFormatter.format(now);
        liveClock.setAttribute("datetime", now.toISOString());
      }

      updateLiveClock();
      window.setInterval(updateLiveClock, 1000);
    }

    function setExpanded(toggle, expanded) {
      var panelId = toggle.getAttribute("aria-controls");
      var panel = panelId ? root.querySelector("#" + CSS.escape(panelId)) : null;
      if (!panel) return;
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      panel.hidden = !expanded;
      var available = toggle.getAttribute("data-sfc-available") || "available";
      var total = toggle.getAttribute("data-sfc-total") || "listed";
      var locationName = toggle.getAttribute("data-sfc-location-name") || "this store";
      toggle.setAttribute("aria-label", expanded
        ? "Hide floor models at " + locationName
        : "View " + available + " of " + total + " available floor models at " + locationName);
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        setExpanded(toggle, toggle.getAttribute("aria-expanded") !== "true");
      });
    });

    locationTriggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        if (event.target.closest("a, button")) return;
        var toggle = trigger.querySelector("[data-sfc-toggle]");
        if (toggle) setExpanded(toggle, toggle.getAttribute("aria-expanded") !== "true");
      });
    });

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var selected = button.getAttribute("data-sfc-filter");
        buttons.forEach(function (item) {
          item.setAttribute("aria-pressed", item === button ? "true" : "false");
        });
        locations.forEach(function (location) {
          location.hidden = selected !== "all" && location.getAttribute("data-sfc-location") !== selected;
          if (selected !== "all" && location.getAttribute("data-sfc-location") === selected) {
            var locationToggle = location.querySelector("[data-sfc-toggle]");
            if (locationToggle) setExpanded(locationToggle, true);
          }
        });
      });
    });
  }

  function initializeAll() {
    document.querySelectorAll("[data-sfc-root]").forEach(initializeCloseout);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeCloseout(event.target.querySelector("[data-sfc-root]"));
  });
})();
